(function($, ns) {
    'use strict';

    var cfg = {
        cache: {
            link: 'a'
        },
        classes: {},
        events: {
            click: 'click'
        },
        options: {
            type: 'image'
        }
    };

    ns.Lightbox = function(container) {
        this.settings = cfg;

        this.container = container;
        this.init();
    };

    ns.Lightbox.prototype = {
        init: function() {
            if (this.container.length) {
                this.cacheItems();
                this.bindEvents();
                this.activate();
            }
        },
        cacheItems: function() {
            var cache = this.settings.cache;

            if (!this.container.is('a')) {
                this.links = this.container.find(cache.link);
            } else {
                this.links = this.container;
            }
        },
        bindEvents: function() {
            var settings = this.settings,
                cache = settings.cache,
                classes = settings.classes,
                events = settings.events,
                options = settings.options,
                self = this;
        },
        activate: function() {
            var settings = this.settings,
                options = settings.options,
                links = this.links;

            for (var i = 0; i < links.length; i++) {
                var link = links.eq(i);

                var hrefAttr = link.attr('href');
                if (hrefAttr === undefined || hrefAttr === false) {
                    var targetAttr = link.data('lightbox-target');
                    if (targetAttr) {
                        options.type = 'inline';
                        link.attr('href', targetAttr);

                        var element = $(targetAttr);
                        if (element.is('video')) {
                            options.callbacks = {
                                open: function() {
                                    element[0].play();
                                },
                                close: function() {
                                    element[0].pause();
                                }
                            };
                        }
                    } else {
                        var childImage = link
                            .find('img')
                            .first()
                            .attr('src');
                        link.attr('href', childImage);
                    }
                }
            }

            links.magnificPopup(options);
        }
    };

    return ns;
})(window.jQuery, window.Dom || {});
